import React from 'react';
import { Navigate } from 'react-router-dom';
import {
    getPreferenciasSnapshot,
    PREFERENCIA_AUDITORIA,
    subscribePreferencias,
} from '@/services/preferencias.service';

export default function AuditoriaEnabledGuard({ children }: { children: React.ReactNode }) {
    const [auditoriaHabilitada, setAuditoriaHabilitada] = React.useState<boolean>(() => {
        const preferencias = getPreferenciasSnapshot();
        return preferencias[PREFERENCIA_AUDITORIA] !== false;
    });

    React.useEffect(
        () =>
            subscribePreferencias((preferencias) => {
                setAuditoriaHabilitada(preferencias[PREFERENCIA_AUDITORIA] !== false);
            }),
        []
    );

    if (!auditoriaHabilitada) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
}
